// components/subscription/PaymentComponent/styles.js
import styled from 'styled-components';

export const PaymentContainer = styled.div`
    max-width: 600px;
    margin: 0 auto;
    padding: ${props => props.theme.spacing.xl};
`;

export const PaymentHeader = styled.div`
    text-align: center;
    margin-bottom: ${props => props.theme.spacing.xl};

    h2 {
        font-size: ${props => props.theme.typography.sizes['2xl']};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.sm};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
    }
`;

export const PaymentDetails = styled.div`
    background: white;
    border-radius: ${props => props.theme.borderRadius.lg};
    padding: ${props => props.theme.spacing.xl};
    box-shadow: ${props => props.theme.shadows.sm};

    .amount-section {
        display: flex;
        align-items: center;
        gap: ${props => props.theme.spacing.md};
        margin-bottom: ${props => props.theme.spacing.xl};
        padding-bottom: ${props => props.theme.spacing.xl};
        border-bottom: 1px solid ${props => props.theme.colors.border};

        svg {
            color: ${props => props.theme.colors.primary.main};
        }

        h3 {
            font-size: ${props => props.theme.typography.sizes.md};
            color: ${props => props.theme.colors.text.secondary};
            margin-bottom: ${props => props.theme.spacing.xs};
        }

        .amount {
            font-size: ${props => props.theme.typography.sizes['2xl']};
            font-weight: ${props => props.theme.typography.weights.bold};
            color: ${props => props.theme.colors.text.primary};
        }
    }

    .actions {
        display: flex;
        gap: ${props => props.theme.spacing.md};
        margin-top: ${props => props.theme.spacing.xl};

        button {
            flex: 1;
        }
    }
`;

export const BankDetails = styled.div`
    margin-bottom: ${props => props.theme.spacing.xl};
    padding: ${props => props.theme.spacing.lg};
    background: ${props => props.theme.colors.background.alt};
    border-radius: ${props => props.theme.borderRadius.md};

    h3 {
        display: flex;
        align-items: center;
        gap: ${props => props.theme.spacing.sm};
        font-size: ${props => props.theme.typography.sizes.lg};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.md};

        svg {
            color: ${props => props.theme.colors.primary.main};
        }
    }
`;

export const BankItem = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${props => props.theme.spacing.sm};
    font-size: ${props => props.theme.typography.sizes.md};

    &:last-child {
        margin-bottom: 0;
    }

    span:first-child {
        color: ${props => props.theme.colors.text.secondary};
    }

    span:last-child {
        font-weight: ${props => props.theme.typography.weights.medium};
    }
`;

export const UploadSection = styled.div`
    h3 {
        display: flex;
        align-items: center;
        gap: ${props => props.theme.spacing.sm};
        font-size: ${props => props.theme.typography.sizes.lg};
        margin-bottom: ${props => props.theme.spacing.md};

        svg {
            color: ${props => props.theme.colors.primary.main};
        }
    }
`;

export const DragDropArea = styled.div`
    border: 2px dashed ${props => props.dragActive ? props.theme.colors.primary.main : props.theme.colors.text.disabled};
    border-radius: ${props => props.theme.borderRadius.lg};
    padding: ${props => props.theme.spacing.xl};
    transition: all ${props => props.theme.transitions.normal};
    background: ${props => props.dragActive ? props.theme.colors.primary.main + '10' : 'transparent'};

    label {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: ${props => props.theme.spacing.sm};
        cursor: pointer;
        text-align: center;

        svg {
            color: ${props => props.theme.colors.text.disabled};
        }

        .file-selected {
            color: ${props => props.theme.colors.primary.main};
            font-weight: ${props => props.theme.typography.weights.medium};
        }

        .file-info {
            font-size: ${props => props.theme.typography.sizes.sm};
            color: ${props => props.theme.colors.text.disabled};
        }
    }
`;

export const PreviewSection = styled.div`
    margin-top: ${props => props.theme.spacing.lg};

    h4 {
        font-size: ${props => props.theme.typography.sizes.md};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.sm};
    }
`;

export const ImagePreview = styled.div`
    width: 100%;
    border-radius: ${props => props.theme.borderRadius.md};
    overflow: hidden;
    border: 1px solid ${props => props.theme.colors.border};

    img {
        width: 100%;
        height: auto;
        display: block;
    }
`;